module.exports = __webpack_public_path__ + "static/media/50.e8ee998d.png";